import { useNavigate } from "react-router-dom";
import { BinsFromVolumeDataInterface } from "../../../../../../redux/interfaces/expedition.interface";
import { expeditionRoutes } from "../../../../../../router/routesConstants";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../../../components/actionMenu/ActionMenu";
import { useAppDispatch } from "../../../../../../redux/hooks";
import {
  openDownloadBinModal,
  setSelectedBinFromVolume,
} from "../../../../../../redux/reducer/expedition.reducer";

function ShowBinsActionButtons({
  itemId,
  crudData,
}: {
  itemId: number;
  crudData: BinsFromVolumeDataInterface;
}) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleShowScannedPackages = () => {
    navigate(
      `${itemId}/${expeditionRoutes.scannedPackages}?sn_bin=${
        crudData.sn_bin
      }&withProblems=${crudData.withProblems ?? ""}`,
    );
  };

  const handleDownloadVolume = () => {
    if (crudData.status !== 1) return;
    dispatch(setSelectedBinFromVolume(crudData));
    dispatch(openDownloadBinModal());
  };

  const items: ActionMenuItem[] = [
    {
      id: "download-bin",
      label: "Descarca bin",
      icon: "DOWNLOAD_CARGO",
      section: "manage",
      tooltip:
        crudData.status === 1
          ? "Deschide formularul pentru descarcarea acestui bin."
          : "Binul trebuie sa fie in stadiul activ pentru descarcare.",
      disabled: crudData.status !== 1,
      onClick: handleDownloadVolume,
    },
    {
      id: "view-packages",
      label: crudData.withProblems ? "Vezi colete neconforme" : "Vezi colete",
      icon: crudData.withProblems ? "UNSCANNED_BOX" : "SCANNED_BOX",
      section: "browse",
      tooltip: crudData.withProblems
        ? "Afiseaza coletele neconforme din acest bin."
        : "Afiseaza coletele scanate din acest bin.",
      onClick: handleShowScannedPackages,
    },
  ];

  return (
    <ActionMenu
      items={items}
      minItemsForMenu={2}
      title={crudData.sn_bin}
      ariaLabel={`Actiuni pentru binul ${crudData.sn_bin}`}
    />
  );
}

export default ShowBinsActionButtons;
